import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom'
import MyLogin from 'myComponents/MyLogin/index';
import MySetup from 'myComponents/MySetup/index';
import MyPasswordRecovery from 'myComponents/MyPasswordRecovery/index';

class MyPrivateRoute extends Component {
    render() {
        return (
            <Route {...this.props}>
                {
                    this.props.authenticated===null ? 
                        <div>connecting...</div> :
                    (
                        // API connection established
                        this.props.authenticated ? (
                            // user is authenticated
                            this.props.customer ? ( 
                                // account has already been set-up (connected with a customer number)
                                this.props.children 
                            ) : (
                                // account has not been set-up yet, so start initial registration wizard
                                <MySetup />
                            )
                        ) : (
                            this.props.passwordRecovery ? (
                                <MyPasswordRecovery username={this.props.passwordRecovery} />
                            ) : (
                                <MyLogin title={this.props.title?this.props.title:"DNS:NET Kundenportal"} />
                            )
                        )
                    )
                }
            </Route>
        );
    }
}

const mapStateToProps = function(state){
    return {
        authenticated: state.api.authenticated,
        customer: state.profile && state.profile.customer,
        passwordRecovery: state.api.passwordRecovery,
        recoverPasswordFailed: state.profile && state.profile.recoverPasswordFailed,
    }
}

export default withRouter(connect(mapStateToProps)(MyPrivateRoute));
